






import EventCreate from '@/components/Templates/User/Event/Create/EventCreate.vue';
import EventBus from '@/eventBus';

export default {
    name: 'CoEventCreate',
    components: {
        EventCreate,
    },
    watch: {
        '$store.state.space.EventsOff': {
            handler(isEventsOff) {
                if (!isEventsOff) {
                    return;
                }

                // Guard direct navigation so hidden create links cannot be bypassed from the browser URL.
                EventBus.$emit('ERROR', {
                    Message: this.$t('messages.eventSystemDisabled'),
                    Details: '',
                });
                this.$router.replace('/events');
            },
            immediate: true,
        },
    },
};
